import { z } from 'zod'

/**
 * Shape of the static `version.json` emitted into the web build (see
 * `vite.config.ts`). Polled at runtime to detect a newer deploy.
 *
 * Tolerant of unknown keys on purpose: an old tab reads the *new* deploy's
 * version.json, so a field added here would fail the parse and quietly switch
 * off the refresh banner — exactly when a stale tab most needs it.
 */
export const versionDtoSchema = z.object({
  sha: z.string().min(1),
  builtAt: z.string().optional(),
})

export type VersionDto = z.infer<typeof versionDtoSchema>
